<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <span class="navbar-item" href="https://bulma.io">
        <router-link :to="{ name: 'home' }" class="navbar-item">
          <img src="@/assets/logo.svg" />
        </router-link>
      </span>

      <span v-if="alerts > 0" class="navbar-item alerts">
        <div class="alerts-wrapper">
          <router-link to="/notifications">
            <img class="bell" src="@/assets/bell.svg" />
            <span>{{ alerts }} notificaciones</span>
          </router-link>
        </div>
      </span>

      <a
        role="button"
        @click="menuVisible = !menuVisible"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div
      v-if="menuVisible"
      id="mainMenu"
      :class="[{ 'is-active': menuVisible }, 'navbar-menu']"
    >
      <div class="navbar-end">
        <template v-for="item in menuRoutes">
          <router-link
            @click.native="close()"
            :to="{ name: item.name }"
            v-bind:key="item.name"
            class="navbar-item"
            exact
          >
            <span>{{ item.meta.title() }}</span>
          </router-link>
        </template>
        <a
          class="navbar-item has-text-grey is-size-7"
          v-for="(lang, i) in $store.getters.otherLocales"
          :key="`Lang${i}`"
          @click="setLocale(lang)"
        >
          <span v-if="lang == 'gl'">{{ $t("page.title.change_to_gl") }}</span>
          <span v-if="lang == 'es'">{{ $t("page.title.change_to_es") }}</span>
          <span v-if="lang == 'pt'">{{ $t("page.title.change_to_pt") }}</span>
        </a>
        <a
          class="navbar-item has-text-primary is-size-7"
          @click.prevent="closeSession()"
        >
          {{ $t("page.title.leave") }}
        </a>
      </div>
    </div>

    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <template v-for="item in menuRoutes">
          <router-link
            :to="{ name: item.name }"
            v-bind:key="item.name"
            class="navbar-item"
          >
            {{ item.meta.title() }}
          </router-link>
        </template>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">{{ $i18n.locale }}</a>

          <div class="navbar-dropdown">
            <a
              class="navbar-item"
              v-for="(lang, i) in $store.getters.otherLocales"
              :key="`Lang${i}`"
              @click="setLocale(lang)"
            >
              {{ lang }}
            </a>
          </div>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a class="button is-light" @click.prevent="closeSession()">Salir</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<style>
.navbar-item.alerts {
  flex-grow: 2;
  text-align: right;
}
.alerts-wrapper {
  width: 100%;
}
.navbar-item.alerts a {
  float: right;
  font-size: 14px;
  color: red;
}

.bell {
  height: 15px;
  margin-right: 5px;
}
</style>

<script>
import { MENU_ROUTES } from "@/router"
import { mapActions } from "vuex"
import api from "@/api"

export default {
  name: "MainHeader",
  data() {
    return {
      menuVisible: false,
      menuRoutes: MENU_ROUTES,
      alerts: 0,
    }
  },
  mounted() {
    this.refreshAlerts()
  },
  methods: {
    ...mapActions(["logOut", "setLocale"]),
    close() {
      this.menuVisible = false
    },
    closeSession() {
      this.logOut()
    },
    refreshAlerts() {
      api.getUnreadNotifications().then((response) => {
        this.alerts = response.data.count
      })
    },
  },
  watch: {
    $route(to, from) {
      this.refreshAlerts()
    },
  },
}
</script>
